'use client';
import { createPreset } from "../createPreset.js";
import { body1StrongClassNames, useBody1StrongStyles } from "./useBody1StrongStyles.styles.js";
/**
 * Text preset component for the Body1Strong typography variant
 */ export const Body1Strong = createPreset({
    useStyles: useBody1StrongStyles,
    className: body1StrongClassNames.root,
    displayName: 'Body1Strong'
});
